import request from "@/utils/request";

// 减碳值详情
export function carbonReductionDetail() {
  return request({
    url: "/myCenter/carbonReductionDetail",
    method: "get",
  });
}

// 快捷匹配
export function myDonatemMatch(data) {
  return request({
    url: "/myDonate/match",
    method: "post",
    data,
  });
}

// 我登记的衣物
export function myClothes(params) {
  return request({
    url: "/myCenter/myClothes",
    method: "get",
    params,
  });
}

// 添加衣物登记 (保存按钮)
export function addMyClothes(data) {
  return request({
    url: "/myCenter/addMyClothes",
    method: "post",
    data,
  });
}

// 添加信息侧边栏
export function myDonateQueryCondition() {
  return request({
    url: "/myDonate/myDonateQueryCondition",
    method: "get",
  });
}

// 匹配自己已经邮寄-未接
export function alreadyMail(data) {
  return request({
    url: "/myDonate/alreadyMail",
    method: "post",
    data,
  });
}

// 送货上门邮寄-未接
export function doorMail(params) {
  return request({
    url: "/myDonate/doorMail",
    method: "get",
    params,
  });
}

// 微信分享参数接口
export function wechatShare(data) {
  return request({
    url: "/wechat/share",
    method: "post",
    data,
  });
}

// 收件人地址接口
export function getReceiverAddress() {
  return request({
    url: "/myDonate/getReceiver",
    method: "get",
  });
}

// 物流公司列表
export function expressCompanyList() {
  return request({
    url: "/myAddress/expressCompanyList",
    method: "get",
  });
}

// 预约取件
export function expressOrder(data) {
  return request({
    url: "/kdniao/oOrder",
    method: "post",
    data,
  });
}

// 物流信息
export function expressInfo(data) {
  return request({
    url: "/kdniao/query",
    method: "get",
    data,
  });
}
